'use strict';

angular.module('webAgro1App')
// eslint-disable-next-line max-lines-per-function, max-params
  .controller('RecomendadoAplicadoCtrl', function($scope, $rootScope, $filter, filterFilter, $q, $timeout,
    GruposService, HistoricosService, AtividadesService, LoadingService, PeriodSelectService, MessagesService,
    RecomendadoAplicadoService, OperacoesService) {
    const genericError = function(error) {
      LoadingService.hideLoading();
      MessagesService.alert('Falha ao carregar dados, tente novamente mais tarde.');
      console.error('Erro ao carregar dados', error);
    };

    const preventDefault = function(event) {
      if (event) {
        event.preventDefault();
      }
    };

    $scope.init = function() {
      LoadingService.showLoading();

      if ($scope.barChart) {
        $scope.barChart.destroy();
      }

      $scope.filters = {};
      $scope.period = {
        eventDates: [],
        periodo: ''
      };

      $rootScope.initialize.then(function() {
        $scope.view = 'chart';
        $scope.filtroPeriodo = PeriodSelectService.getFilterPeriodo($scope.safras);
        $scope.setPropriedade();
        AtividadesService.list().then(function(result) {
          $scope.atividades = result.data;
        }, genericError);
        OperacoesService.getTipoOperacoesTodas().then(function(result) {
          $scope.operacoes = result.data;
          $scope.filters.operacao = $rootScope.parametros.operacao_pulverizacao;
        }, genericError);
        GruposService.list().then(function(result) {
          $scope.gruposInsumos = result.data;
          $scope.getDados();
        }, genericError);
      }, $rootScope.errorRootInitialize);
    };

    const drawChart = function() {
      $timeout(function() {
        if ($scope.barChart) {
          $scope.barChart.destroy();
        }

        const ctx = document.getElementById('grafico').getContext('2d');
        $scope.barChart = RecomendadoAplicadoService.drawChart(ctx, $scope.produtos);
      });
    };

    $scope.changeView = function() {
      if ($scope.view === 'chart') {
        $scope.view = 'table';
      } else {
        $scope.view = 'chart';
        drawChart();
      }
    };

    $scope.init();

    const updateGlebaFilters = function() {
      $scope.loadingSelectFilters = true;
      HistoricosService.listGlebas({ propriedade: $scope.filters.propriedade.id }).then(function(result) {
        $scope.glebas = result.data;
      }, genericError)
        .finally(function() {
          $scope.loadingSelectFilters = false;
        });
    };

    $scope.resetPeriodsFilter = function() {
      $scope.filters.dataInicial = null;
      $scope.filters.dataFinal = null;
      $scope.period = {
        eventDates: [],
        periodo: ''
      };
    };

    $scope.openPeriodsFilter = function(event) {
      preventDefault(event);
      PeriodSelectService.openPeriodSelection($scope.period, $scope.filters);
    };

    $scope.setPeriodo = function(periodo, event) {
      preventDefault(event);
      $scope.filters.dataInicial = periodo.dataInicial;
      $scope.filters.dataFinal = periodo.dataFinal;
      $scope.period.periodo = periodo.descricao;
    };

    $scope.setPropriedade = function(propriedade, event) {
      preventDefault(event);
      $scope.filters.propriedade = propriedade || $rootScope.currentPropriedade;
      $scope.setPeriodo($scope.filtroPeriodo[0]);
      updateGlebaFilters();
    };

    $scope.setFilterAttribute = function(attribute, object, event) {
      preventDefault(event);
      $scope.filters[attribute] = object;
    };

    $scope.getDados = function() {
      LoadingService.showLoading();
      RecomendadoAplicadoService.listRecomendadoAplicado($scope.filters).then(function(result) {
        $scope.produtos = result.data;
        drawChart();
      }, genericError)
        .finally(LoadingService.hideLoading);
    };

    $scope.difference = function(produto) {
      if (produto.total_aplicado && produto.total_recomendado) {
        return produto.total_aplicado - produto.total_recomendado;
      }
    };

    $scope.percent = function(produto) {
      if (produto.total_aplicado && produto.total_recomendado) {
        return $scope.difference(produto) / produto.total_recomendado * 100;
      }
    };
  });
